import { PrismicRichText } from '@prismicio/react'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  resetNextUuid,
} from 'react-accessible-accordion'
import styles from './ProductInfoBlocks.module.css'

const ProductInfoBlocks = ({ slice, fullWidthOnMobile = false }) => {
  const { items } = slice
  const { container } = slice.primary
  resetNextUuid()

  const wrapperClasses = [
    container && styles.wrapper,
    styles.productInfoBlocks,
    container && fullWidthOnMobile && styles.fullWidthMobile,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={wrapperClasses}>
      <Accordion allowZeroExpanded>
        {items.map((item, index) => (
          <AccordionItem
            uuid={`productInfoBlock--${index}`}
            key={`productInfoBlock--${index}`}
            className={styles.blockItem}
          >
            <AccordionItemHeading className={styles.blockItemHeading}>
              <AccordionItemButton className={styles.blockItemButton}>
                <div className={styles.blockItemToggle}>
                  <img
                    className={styles.blockItemToggle__img}
                    src={item.icon.url}
                    alt={item.icon.alt || 'blockItemToggle'}
                  />
                  <div className={styles.blockItemToggle__text}>
                    <p className={styles.blockItemToggle__heading}>
                      {item.heading[0].text}
                    </p>
                    <p> {item.subHeading[0].text}</p>
                  </div>
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={styles.blockItemPanel}>
              <div>
                <PrismicRichText field={item.text} />
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

export default ProductInfoBlocks
